import { ref, watch } from 'vue';
import { injectLocal, provideLocal, useMounted } from '@vueuse/core';
import { Cookie } from '@vue-util/cookie';
import { cookies } from 'config';

import { userInfoParser } from './parsers';

const USER_INFO = Symbol.for('USER_INFO');

export const useUser = () => injectLocal(USER_INFO);

export const useUserProvide = () => {
  const userId = ref('');
  const userGuid = ref('');
  const bagGuid = ref('');
  /** @type {import('vue').Ref<import('./types').userInfoParsed | null>} */
  const userInfo = ref(null);
  const isMounted = useMounted();

  function _getUserId() {
    return Cookie.get(cookies.userId);
  }

  function _getUserGuid() {
    return Cookie.get(cookies.userGuid);
  }

  function _getBagGuid() {
    return Cookie.get(cookies.bagGuid);
  }
  /**
   *
   * @returns {import('./types').mcomUserInfo | import('./types').bcomUserInfo | null}
   */
  function _getUserInfo() {
    const userInfoLS = localStorage.getItem(`hnfsr_${userId.value}`);
    if (!userId.value || !userInfoLS) return null;
    try {
      return JSON.parse(userInfoLS);
    } catch (e) { /* istanbul ignore next */
      throw new Error('Error parsing user data');
    }
  }

  function updateUserInfo() {
    userInfo.value = _getUserInfo();
  }

  watch(isMounted, () => {
    userId.value = _getUserId();
    userGuid.value = _getUserGuid();
    bagGuid.value = _getBagGuid();
  });

  watch(userId, () => {
    const rawUserInfo = _getUserInfo();
    // check README file in ./parsers for more details
    userInfo.value = userInfoParser(rawUserInfo);
  });

  provideLocal(USER_INFO, {
    userId,
    userGuid,
    bagGuid, // TODO: move to bag?
    userInfo,
    updateUserInfo,
  });
};
